$(".size-guide-popup-link").on('click', function (e) {
  e.preventDefault();
  $('body').addClass('size-guide-popup-open');
});

$(".size-guide-popup-cancel").click(function () {
  $("body").removeClass("size-guide-popup-open");
});

$(".fins-popup").on('click', function (e1) {
  e1.preventDefault();
  $('body').addClass('fins-popup-open');
});

$(".fins-popup-cancel").click(function () {
  $("body").removeClass("fins-popup-open");
});

$(".propad-popup").on('click', function (e1) {
  e1.preventDefault();
  $('body').addClass('propad-popup-open');
});

$(".propad-popup-cancel").click(function () {
  $("body").removeClass("propad-popup-open");
});

$(".custom-select-dropdown").each(function(index) {
  $(this).on('click', function () {
    $('.custom-select-dropdown-items').slideToggle();
  });
});
$(".addfins").on("click",function(){
	var varid = $(this).attr("var-id");
  	$("#finsid").val(varid);
    $("#finsid").attr('name', 'id[]');
    $("#propertyfinid").attr('name', 'properties[fin]');
    $("#propertyfinid").val(varid);
  	$(".addfins label").removeClass("selected");
  	$(this).children("label").addClass("selected");
  
});
$(".addpads").on("click",function(){
	var varid = $(this).attr("var-id");
  if(varid == 0){
    $("#padsid").attr('name', '');
  }else
  {
    $("#padsid").val(varid);
    $("#padsid").attr('name', 'id[]');
  }
  	
	$(".selectedpad").html($(this).html());
  	$('.custom-select-dropdown-items').slideUp();
});

$("li.li1").hover(function(){
	var bgimg = $(this).attr("bg-img");
  if(bgimg.indexOf(".gif") == -1){
  	$(".megamenu1image1").attr("src",bgimg);
    if($(this).attr("m1-title"))
    {
      $(".menu1title").html($(this).attr("m1-title"));
    }
    else{
      $(".menu1title").html($(".megamenu1image1").attr("m1-title"));
    }
    if($(this).attr("m1-subtitle"))
    {
      $(".menu1subtitle").html($(this).attr("m1-subtitle"));
    }else{
      $(".menu1subtitle").html($(".megamenu1image1").attr("m1-subtitle"));
    }
    if($(this).attr("m1-shortdesc")){
      $(".menu1shortdesc").html($(this).attr("m1-shortdesc"));
    }else{
      $(".menu1shortdesc").html($(".megamenu1image1").attr("m1-shortdesc"));
    }
    
  }
});
/*
$("li.li1").mouseout(function(){
	var bgimg = $(".megamenu1_image1").attr("original-image");
  	$(".megamenu1_image1").removeAttr("style");
    $(".megamenu1_image1").css("background-image", "url(" + bgimg + ")");
});*/
$(".megamenu1image1").hover(function(){
	var bgimg = $(".megamenu1_image1").attr("original-image");
  $(".megamenu1image1").attr("src",bgimg);
});
$("li.li2").hover(function(){
	var bgimg = $(this).attr("bg-img");
  if(bgimg.indexOf(".gif") == -1){
  	$(".megamenu2image1").attr("src",bgimg);
    if($(this).attr("m2-title"))
    {
      $(".menu2title").html($(this).attr("m2-title"));
    }
    else{
      $(".menu2title").html($(".megamenu2image1").attr("m2-title"));
    }
    if($(this).attr("m2-subtitle"))
    {
      $(".menu2subtitle").html($(this).attr("m2-subtitle"));
    }else{
      $(".menu2subtitle").html($(".megamenu2image1").attr("m2-subtitle"));
    }
    if($(this).attr("m2-shortdesc")){
      $(".menu2shortdesc").html($(this).attr("m2-shortdesc"));
    }else{
      $(".menu2shortdesc").html($(".megamenu2image1").attr("m2-shortdesc"));
    }
  }
});
/*
$("li.li2").mouseout(function(){
	var bgimg = $(".megamenu2_image1").attr("original-image");
  	$(".megamenu2_image1").removeAttr("style");
    $(".megamenu2_image1").css("background-image", "url(" + bgimg + ")");
});*/
$(".megamenu2image1").hover(function(){
	var bgimg = $(".megamenu2_image1").attr("original-image");
  $(".megamenu2image1").attr("src",bgimg);
});